import "./sentry.js"; // side-effect import: initializes Sentry before React loads
import React from "react";
import ReactDOM from "react-dom/client";
import { Sentry } from "./sentry.js";
// Leaflet's stylesheet is global — it sets `position:absolute` on map tiles and
// panes. Importing it here (not only inside a single map component) guarantees
// it's present no matter which map-bearing route mounts first. It used to be
// imported only by MapView (Monitor); a hard reload on any OTHER map page
// (geocercas, dashboard, reportes) loaded tiles as `position:static`, stacking
// them vertically — the "tiles in quadrants + map overlaying buttons" bug.
import "leaflet/dist/leaflet.css";
import "./index.css";
import App from "./App.jsx";
import FallbackErrorPage from "./components/FallbackErrorPage.jsx";
import { isNativeShell } from "./lib/pwa.js";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ eventId }) => <FallbackErrorPage eventId={eventId} />}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register Service Worker: web push + app shell cacheado (instalabilidad PWA).
// Skipped in MODE === "test" to avoid registration noise in Vitest, y dentro del
// contenedor nativo de Capacitor, donde el push es nativo y la caché del SW
// podría servir un bundle viejo dentro del WebView.
// Se chequea el valor y no `"serviceWorker" in navigator`: en contextos no
// seguros (dev server servido por IP de LAN) la propiedad existe pero vale
// undefined, y el register de abajo tiraba TypeError sin que el .catch lo viera.
if (navigator.serviceWorker && import.meta.env.MODE !== "test" && !isNativeShell()) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      // eslint-disable-next-line no-console
      console.error("SW registration failed", err);
    });
  });
}
